import React from "react";
import { AppContext } from "../../contexts/AppContext";
import AuthContext from "../../contexts/AuthContext";
import api from "../../actions/common";
import cogoToast from "cogo-toast";
import { constants } from "../Dashboard/const";

export const useEpisodes = (storyID, args = {}) => {
  const { episodes, episodesDispatch } = React.useContext(AppContext);
  const { token } = React.useContext(AuthContext);
  const [loading, setLoading] = React.useState(false);
  const [loadedOnce, setLoadedOnce] = React.useState(false);

  React.useEffect(() => {
    if (
      !loadedOnce ||
      (episodes.length > 0 && episodes[0].Story._id !== storyID)
    ) {
      getEpisodes(episodesDispatch, storyID, token, args, setLoading);
    }
    setLoadedOnce(true);
  }, [episodes, episodesDispatch, token, storyID]);

  return [episodes, loading];
};

export const useSingleEpisode = (storyID, episodeID, args = {}) => {
  const { episode, episodeDispatch } = React.useContext(AppContext);
  const { token } = React.useContext(AuthContext);
  const [loading, setLoading] = React.useState(false);
  const [loadedOnce, setLoadedOnce] = React.useState(false);

  React.useEffect(() => {
    if (!loadedOnce || episode._id !== episodeID) {
      getEpisode(episodeDispatch, episodeID, token, args, setLoading);
    }
    setLoadedOnce(true);
  }, [episode, episodeDispatch, token, storyID, episodeID]);

  return [episode, loading];
};

export const useEpisode = (storyID, episodeID, args = {}) => {
  // const { episode, episodeDispatch } = useContext(AppContext);
  const { token } = React.useContext(AuthContext);
  const [loading, setLoading] = React.useState(false);

  if (storyID && !episodeID) {
    const setEpisode = (formData) => postEpisode(formData, token, setLoading);
    return [setEpisode, loading];
  } else if (storyID && episodeID) {
    const setEpisode = (formData) => postEpisode(formData, token, setLoading, episodeID);
    return [setEpisode, loading];
  } else {
    return [loading];
  }
};

const getEpisodes = async (dispatch, storyID, token, args, setLoading) => {
  let episodes = [];

  const response = await api.get(
    `/episodes/${storyID}`,
    token,
    args,
    setLoading
  );

  if (response.status || response.success) {
    episodes = response.Episodes.map((episode, index) => ({
      ...episode,
      index: index,
    }));
  } else {
    cogoToast.error(response.message);
    return;
  }

  if (Array.isArray(episodes)) {
    dispatch({
      type: "set",
      payload: episodes,
    });
  }
};

export const getEpisode = async (dispatch, episodeID, token, args, setLoading) => {
  let episode = {};

  const response = await api.get(
    `/episodes/single/${episodeID}`,
    token,
    args,
    setLoading
  );

  if (response.status || response.success) {
    episode = response.Episode;
  } else {
    cogoToast.error(response.message);
    return;
  }
  dispatch({
    type: "set",
    payload: episode,
  });
};

const num = () => Math.floor(Math.random() * constants.covers.length);

const postEpisode = async (formData, token, setLoading, episodeID) => {
  const resp = await episodeID ? api.put(`/episodes/${episodeID}`, token, formData, setLoading) : api.set("/episodes/create", token, formData, setLoading);
  return resp;
};
